import apiClent from '@/clients/apiClient';

export const getBanks = () => apiClent.get('banks');

export const verifyBankAccount = (data) =>
  apiClent.post('banks/verify-account', data);
